var _defs, _circle, _circle2, _g, _g2, _line, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGradient",
    x1: 0,
    y1: 0,
    x2: 512,
    y2: 512
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0284C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0369A1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glowGradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "metalGradient",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("mask", {
    id: "solderingMask"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 512,
    height: 512,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 180,
    fill: "black"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "url(#bgGradient)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 220,
    fill: "url(#glowGradient)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "white",
    strokeWidth: 2,
    strokeOpacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 256 H150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362 256 H462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 50 V150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 362 V462"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 190,
    strokeDasharray: "15,15"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(256 256) scale(0.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-120 -40              L80 -40              Q100 -40 100 -20              L100 20              Q100 40 80 40              L-120 40              Q-140 40 -140 20              L-140 -20              Q-140 -40 -120 -40Z",
    fill: "url(#metalGradient)",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 0 L160 0",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 0,
    r: 8,
    fill: "#FFA500"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "8;12;8",
    dur: "2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.6;1",
    dur: "2s",
    repeatCount: "indefinite"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    x: 256,
    y: 280,
    textAnchor: "middle",
    fill: "white",
    style: {
      fontSize: 120,
      fontWeight: "bold",
      fontFamily: "Arial, sans-serif"
    }
  }, "\n      D.I\n    "), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 186,
    y1: 310,
    x2: 326,
    y2: 310,
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "0,150;150,0",
    dur: "2s",
    fill: "freeze"
  })))), /*#__PURE__*/React.createElement("text", {
    x: 256,
    y: 350,
    textAnchor: "middle",
    style: {
      fontSize: 48,
      fontFamily: "Arial, sans-serif",
      letterSpacing: 4
    },
    fill: "url(#metalGradient)"
  }, "\n    TECH\n  "), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "white",
    fillOpacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 256,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 462,
    cy: 256,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 50,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 462,
    r: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a20687955bb195d1c2d8ee42f9d3ca07.svg";
export { ForwardRef as ReactComponent };